import $ from 'jquery';
import getInnerHeightValues from './innerHeightValues';

const ROOM_SLIDER_FLOOR = 0;
const ROOM_SLIDER_CEIL = 11;
const ROOM_SLIDER_STEP = 1;
const ROOM_SLIDER_PRECISION = 1;
const ROOM_VALUES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'];

const FLOOR_SLIDER_FLOOR = 0;
const FLOOR_SLIDER_CEIL = 20;
const FLOOR_SLIDER_STEP = 1;

const INNER_HEIGHT_SLIDER_FLOOR = 0;
const INNER_HEIGHT_SLIDER_CEIL = 10.1;
const INNER_HEIGHT_SLIDER_STEP = 0.1;
const INNER_HEIGHT_SLIDER_PRECISION = 1;
const INNER_HEIGHT_SLIDER_VALUES = getInnerHeightValues();

const FLOORS_IN_BUILDING_SLIDER_FLOOR = 1;
const FLOORS_IN_BUILDING_SLIDER_CEIL = 10;
const FLOORS_IN_BUILDING_SLIDER_STEP = 1;

const BATHROOM_COUNT_FLOOR = 0;
const BATHROOM_COUNT_CEIL = 2;
const BATHROOM_COUNT_STEP = 1;
const BATHROOM_VALUES = ['0', '1', '2+'];

const FLOOR_VALUES = [
	'underground4',
	'underground3',
	'underground2',
	'underground1',
	'basement',
	'suteren',
	'halfSuteren',
	'downstairs',
	'highDownstairs',
	'halfUpstairs',
	'1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'
];

const BUILDING_MATERIALS = {
	wood: ['wood', 'woodHouse'],
	brick: ['brick', 'rockAndBrick'],
	panel: ['panel', 'shutter'],
	lightStructure: ['lightStructure'],
	otherBuildingMaterial: ['adobe', 'silicate', 'proconcept', 'mixedMasonry', 'passiveHouse', 'otherBuildingMaterial']
};

const HEATING_TYPES = {
	gas: ['gasCirco', 'gasConvector', 'gasHera', 'gasAndAlternative'],
	electric: ['electric'],
	remoteHeating: ['remoteHeating', 'remoteHeatingWithOwnMeasurer'],
	otherHeating: ['houseCentralized', 'houseCentralizedWithUniqueMeter', 'geotermic', 'furnace', 'stove', 'fanCoil', 'otherHeating'],
	nothing: ['nothing']
};

const ELEVATOR_VALUES = {
	NONE: ['none'],
	EXIST: ['key', 'caller', 'service']
};

const COMFORT_LEVELS = {
	double: ['doubleComfort', 'luxurious'],
	full: ['fullComfort', 'comfort'],
	other: ['withoutComfort', 'halfComfort']
};

const LIVING_ROOM_ORIENTATIONS = {
	north: ['north', 'northeast', 'northwest'],
	east: ['east', 'northeast', 'southeast'],
	south: ['south', 'southeast', 'southwest'],
	west: ['west', 'northwest', 'southwest']
};

const TERRACE_PROPERTIES = {
	terrace: ['terrace', 'roofTerrace', 'balcony', 'loggia', 'frenchBalcony']
};

const MISCELLANEOUS_PROPERTIES = {
	pool: ['pool'],
	withGardenAccess: ['withGardenAccess'],
	topFloor: ['topFloor']
};

const PARKING_ARRAY = ['roomGarage', 'closedPlace', 'openedPlace', 'publicPayment', 'publicFree'];

const ALLOWED_PROPERTIES = [
	'bathroomsMax',
	'bathroomsMin',
	'buildingStructure',
	'comfortLevel',
	'conditionOfProperty',
	'elevator',
	'floor',
	'floorMax',
	'floorMin',
	'heating',
	'innerHeight',
	'innerHeightMax',
	'innerHeightMin',
	'keyWord',
	'livingRoomOrientation',
	'parkingOption',
	'project.id',
	'isOwnedByFactoring',
	'rooms.type',
	'roomsMax',
	'roomsMin',
	'staircaseType',
	'storey',
	'floorsInBuildingMax',
	'floorsInBuildingMin',
	'view'
];

export const AdvancedSearchComponent = {
	bindings: {
		advancedSearchFunction: '&',
		saveAdvancedSearchDataFunction: '&',
		ingatlanTipusa: '<'
	},
	templateUrl: 'advanced-search.html',
	controller: class AdvancedSearchComponent {
		constructor($timeout, niceUrlService, $scope) {
			'ngInject';
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.niceUrlService = niceUrlService;
			this.$scope = $scope;
			this.FLOOR_VALUES = FLOOR_VALUES;
			this.BATHROOM_VALUES = BATHROOM_VALUES;
			this.firstLoad = true;
			this.bathroom = this.bathroom || {
				bathroomsMin: BATHROOM_VALUES[BATHROOM_COUNT_FLOOR],
				bathroomsMax: BATHROOM_VALUES[BATHROOM_COUNT_CEIL]
			};
			this.rooms = this.rooms || {
				roomsMax: ROOM_VALUES[ROOM_VALUES.length - 1],
				roomsMin: ROOM_VALUES[ROOM_SLIDER_FLOOR]
			};
			this.innerHeight = this.innerHeight || {
				innerHeightMax: INNER_HEIGHT_SLIDER_VALUES[INNER_HEIGHT_SLIDER_VALUES.length - 1],
				innerHeightMin: INNER_HEIGHT_SLIDER_VALUES[INNER_HEIGHT_SLIDER_FLOOR]
			};
		}

		$onInit() {
			// a szülő komponensbe is mentjük az adatokat
			this.saveAdvancedSearchData();
			this.$scope.$emit('advancedSearchInitialized');
			this.setAdvancedSearchTabPosition();

			this.$scope.$on('resetSearch', () => {
				this.resetAdvancedSearch();
			});
			window.addEventListener('hashchange', ()=> {
				this.$scope.$apply(()=> {
					if (window.location.hash.indexOf('/oldal=') == -1) {
						this.startSearch();
					}
				});
			}, false);
			if (window.location.hash) {
				this.startSearch(); 
			} else {
				this.resetAdvancedSearchFormData();
				this.resetCheckBoxesData();
			}

		}

		$onChanges(changes) {
			if (changes.ingatlanTipusa) {
				if (Number.isInteger(this.ingatlanTipusa)) {
					if (this.ingatlanTipusa >= 3) {
						this.resetAdvancedSearch();
						this.$scope.$emit('hideAdvancedSearch');
					}
				}
			}
		}
		startSearch() {
			this.advancedSearchFormData = this.niceUrlService.preLoadDataFromNiceUrl(window.location.hash);
			this.removeOtherProperties();
			this.advancedSearchFormData.conditionOfProperty = this.advancedSearchFormData.conditionOfProperty || [];
			this.advancedSearchFormData.buildingStructure = this.advancedSearchFormData.buildingStructure || [];
			this.advancedSearchFormData.heating = this.advancedSearchFormData.heating || [];
			this.advancedSearchFormData.comfortLevel = this.advancedSearchFormData.comfortLevel || [];
			this.advancedSearchFormData.parkingOption = this.advancedSearchFormData.parkingOption || [];
			this.advancedSearchFormData.view = this.advancedSearchFormData.view || [];
			this.advancedSearchFormData.staircaseType = this.advancedSearchFormData.staircaseType || [];
			this.advancedSearchFormData.livingRoomOrientation = this.advancedSearchFormData.livingRoomOrientation || [];
			this.advancedSearchFormData['rooms.type'] = this.advancedSearchFormData['rooms.type'] || [];
			this.advancedSearchFormData.elevator = this.advancedSearchFormData.elevator || [];
			// this.advancedSearchFormData.miscellaneous = this.advancedSearchFormData.miscellaneous || [];
			this.advancedSearchFormData.hasPoolOrSwimmingPool = this.advancedSearchFormData.hasPoolOrSwimmingPool || false;
			this.advancedSearchFormData.hasGardenOrPark = this.advancedSearchFormData.hasGardenOrPark || false;
			this.advancedSearchFormData.isInAttic = this.advancedSearchFormData.isInAttic || false;

			this.slidersInitialized = true;
			this.resetCheckBoxesData();
			this.initAdvancedSearchModels();
			if (this.isOwnedByFactoring && this.isOwnedByFactoring.length && this.isOwnedByFactoring[0] == 'true') {
				this.$scope.$emit('isOwnedByFactoring', {value: true});
			}
			this.doAdvancedSearch(); 

		}
		setAdvancedSearchTabPosition() {
			let ctrl = this;

			$(document).ready(() => {
				let result = 'top';
				let dialogContent = $('md-dialog-content');

				dialogContent.scroll(() => {
					let dialogContentScrollTop = dialogContent.scrollTop();
					let headerHeight = $('.md-dialog-container .md-dialog-header').outerHeight();
					let searchHeight = $('.md-dialog-container .m03-main-search').outerHeight();
					let advancedSearchOpenerHeight = $('.md-dialog-container .m15-advanced-search-opener').outerHeight();
					let tabsWrapperHeight = $('.md-dialog-container md-tabs-wrapper').outerHeight();
					let advancedSearchBoxMarginTop = parseInt($('.md-dialog-container .m15-advanced-search-container').css('margin-top'));

					if (dialogContentScrollTop && headerHeight && searchHeight &&
						advancedSearchOpenerHeight && tabsWrapperHeight && advancedSearchBoxMarginTop) {
						let threshold = headerHeight + searchHeight + advancedSearchOpenerHeight + tabsWrapperHeight + advancedSearchBoxMarginTop;

						if (dialogContentScrollTop > threshold) {
							result = 'bottom';
						} else {
							result = 'top';
						}
					}

					ctrl.advancedSearchTabPosition = result;
					if (!ctrl.$scope.$$phase) {
						ctrl.$scope.$apply();
					}
				});
			});
		}

		modifyUrl() {
			this.saveAdvancedSearchData();

		}
		doAdvancedSearch(noHashCreation) {
			if (this.mNumber) {
				window.location.href = '/ingatlan/' + this.mNumber;
			} else {
				this.advancedSearchFunction({
					data: this.advancedSearchFormData
				});
			}
		}

		resetAdvancedSearch(fromClick) {
			this.resetAdvancedSearchFormData();
			this.resetCheckBoxesData();
			this.saveAdvancedSearchData();
			if (this.isOwnedByFactoring) {
				this.$scope.$emit('isOwnedByFactoring', {value: false});
			}
		}

		initAdvancedSearchModels() {
			this.initAdvancedSearchModelSingleValue('conditionOfProperty', 'conditionOfProperty');
			this.initAdvancedSearchModelSingleValue('view', 'view');
			this.initAdvancedSearchModelSingleValue('staircaseType', 'staircaseType');
			this.initAdvancedSearchModelSingleValue('livingRoomOrientation', 'livingRoomOrientation');

			this.initAdvancedSearchModelValue('hasGardenOrPark');
			this.initAdvancedSearchModelValue('hasPoolOrSwimmingPool');
			this.initAdvancedSearchModelValue('isInAttic');

			this.initAdvancedSearchModelArray('heating', 'heating', HEATING_TYPES);
			this.initAdvancedSearchModelArray('buildingStructure', 'buildingStructure', BUILDING_MATERIALS);
			this.initAdvancedSearchModelArray('comfortLevel', 'comfortLevel', COMFORT_LEVELS);
			this.initAdvancedSearchModelArray('rooms.type', 'roomTypes', TERRACE_PROPERTIES);
			// this.initAdvancedSearchModelArray('miscellaneous', 'miscellaneous', MISCELLANEOUS_PROPERTIES);
			this.initAdvancedSearchModelArray('elevator', 'elevator', ELEVATOR_VALUES);
			this.initBathroomCountModel(this.advancedSearchFormData);
			this.initRoomModel(this.advancedSearchFormData);
			this.initInnerHeight(this.advancedSearchFormData);
			this.keyWord = this.advancedSearchFormData.keyWord;
			this.projectId = this.advancedSearchFormData['project.id'];
			this.isOwnedByFactoring = this.advancedSearchFormData.isOwnedByFactoring;
			this.parking = !!this.advancedSearchFormData.parkingOption.length;
		}

		initBathroomCountModel(formData) {
			if (formData.hasOwnProperty('bathroomsMin')) {
				this.bathroom = {};
				this.bathroomSlider = {};
				this.bathroom.bathroomsMin = BATHROOM_VALUES[parseInt(formData.bathroomsMin, 10)];
				this.bathroomSlider.bathroomsMin = parseInt(formData.bathroomsMin, 10);
				if (formData.hasOwnProperty('bathroomsMax') && formData.bathroomsMax) {
					this.bathroom.bathroomsMax = BATHROOM_VALUES[parseInt(formData.bathroomsMax, 10)];
					this.bathroomSlider.bathroomsMax = parseInt(formData.bathroomsMax, 10);
				} else {
					this.bathroom.bathroomsMax = BATHROOM_VALUES[BATHROOM_COUNT_CEIL];
					this.bathroomSlider.bathroomsMax = BATHROOM_COUNT_CEIL;
				}
			}
		}

		initRoomModel(formData) {
			if (formData.hasOwnProperty('roomsMin')) {
				this.rooms = {};
				this.roomsSlider = {};
				this.rooms.roomsMin = ROOM_VALUES[parseInt(formData.roomsMin, 10)];
				this.roomsSlider.roomsMin = parseInt(formData.roomsMin, 10);
				if (formData.hasOwnProperty('roomsMax') && formData.roomsMax) {
					this.rooms.roomsMax = ROOM_VALUES[parseInt(formData.roomsMax, 10)];
					this.roomsSlider.roomsMax = parseInt(formData.roomsMax, 10);
				} else {
					this.rooms.roomsMax = ROOM_VALUES[ROOM_VALUES.length - 1];
					this.roomsSlider.roomsMax = ROOM_SLIDER_CEIL;
				}
			}
		}

		initInnerHeight(formData) {
			if (formData.hasOwnProperty('innerHeightMin')) {
				this.innerHeight = {};
				this.innerHeightSlider = {};
				this.innerHeight.innerHeightMin = INNER_HEIGHT_SLIDER_VALUES[parseFloat(formData.innerHeightMin) * 10];
				this.innerHeightSlider.innerHeightMin = parseFloat(formData.innerHeightMin).toFixed(1);
				if (formData.hasOwnProperty('innerHeightMax') && formData.innerHeightMax) {
					this.innerHeight.innerHeightMax = INNER_HEIGHT_SLIDER_VALUES[parseFloat(formData.innerHeightMax) * 10];
					this.innerHeightSlider.innerHeightMax = parseFloat(formData.innerHeightMax).toFixed(1);
				} else {
					this.innerHeight.innerHeightMax = INNER_HEIGHT_SLIDER_VALUES[INNER_HEIGHT_SLIDER_VALUES.length - 1];
					this.innerHeightSlider.innerHeightMax = INNER_HEIGHT_SLIDER_CEIL;
				}
			}
		}

		initAdvancedSearchModelSingleValue(searchModelName, controllerModelName) {
			this.advancedSearchFormData[searchModelName].forEach((item) => {
				this[controllerModelName][item] = true;
			});
		}

		initAdvancedSearchModelArray(searchModelName, controllerModelName, remapArray) {
			this.advancedSearchFormData[searchModelName].forEach((item) => {
				for (let key in remapArray) {
					if (remapArray[key].indexOf(item) > -1) {
						this[controllerModelName][key] = true;
					}
				}
			});
		}

		initAdvancedSearchModelValue(attr) {
			this.advancedSearchFormData[attr] = false;
		}

		removeOtherProperties() {
			for (let key in this.advancedSearchFormData) {
				if (ALLOWED_PROPERTIES.indexOf(key) == -1) {
					delete this.advancedSearchFormData[key];
				}
			}
		}

		resetCheckBoxesData() {
			this.elevator = {};
			this.conditionOfProperty = {};
			this.heating = {};
			this.buildingStructure = {};
			this.comfortLevel = {};
			this.parking = {};
			this.roomTypes = {};
			this.miscellaneous = {};
			this.view = {};
			this.staircaseType = {};
			this.livingRoomOrientation = {};
			this.keyWord = null;
			this.mNumber = null;
		}

		resetAdvancedSearchFormData() {
			this.advancedSearchFormData = {
				'conditionOfProperty': [],
				'buildingStructure': [],
				'heating': [],
				'comfortLevel': [],
				'parkingOption': [],
				'view': [],
				'staircaseType': [],
				'rooms.type': [],
				'keyWord': null,
				'mNumber': null,
				'roomsMin': ROOM_SLIDER_FLOOR,
				'roomsMax': '',
				'bathroomsMin': BATHROOM_COUNT_FLOOR,
				'bathroomsMax': '',
				'floorMin': FLOOR_SLIDER_FLOOR,
				'floorMax': FLOOR_SLIDER_CEIL,
				'innerHeightMin': INNER_HEIGHT_SLIDER_FLOOR,
				'innerHeightMax': '',
				'floorsInBuildingMin': FLOORS_IN_BUILDING_SLIDER_FLOOR,
				'floorsInBuildingMax': FLOORS_IN_BUILDING_SLIDER_CEIL,
				'isInAttic': false,
				'hasPoolOrSwimmingPool': false,
				'hasGardenOrPark': false
			};
		}

		initSliders() {
			this.rooms.roomsMin = this.rooms.roomsMin || ROOM_SLIDER_FLOOR;
			this.rooms.roomsMax = this.rooms.roomsMax || ROOM_VALUES[ROOM_VALUES.length - 1];
			this.roomsSliderOptions = {
				floor: ROOM_SLIDER_FLOOR,
				ceil: ROOM_SLIDER_CEIL,
				step: ROOM_SLIDER_STEP,
				precision: ROOM_SLIDER_PRECISION,
				showTicks: false,
				onChange: this.saveRooms.bind(this)
			};

			this.bathroom.bathroomsMin = this.bathroom.bathroomsMin || BATHROOM_COUNT_FLOOR;
			this.bathroom.bathroomsMax = this.bathroom.bathroomsMax || BATHROOM_VALUES[2];
			this.bathroomsSliderOptions = {
				floor: BATHROOM_COUNT_FLOOR,
				ceil: BATHROOM_COUNT_CEIL,
				step: BATHROOM_COUNT_STEP,
				showTicks: false,
				onChange: this.saveBathrooms.bind(this)
			};

			this.floorSliderOptions = {
				floor: FLOOR_SLIDER_FLOOR,
				ceil: FLOOR_SLIDER_CEIL,
				step: FLOOR_SLIDER_STEP,
				showTicks: false,
				onChange: this.floorSliderChanged.bind(this)
			};

			this.innerHeight.innerHeightMin = INNER_HEIGHT_SLIDER_FLOOR;
			this.innerHeight.innerHeightMax = INNER_HEIGHT_SLIDER_VALUES[INNER_HEIGHT_SLIDER_VALUES.length - 1];
			this.innerHeightSliderOptions = {
				floor: INNER_HEIGHT_SLIDER_FLOOR,
				ceil: INNER_HEIGHT_SLIDER_CEIL,
				step: INNER_HEIGHT_SLIDER_STEP,
				precision: INNER_HEIGHT_SLIDER_PRECISION,
				showTicks: false,
				onChange: this.setInnerHeight.bind(this)
			};

			this.floorsInBuildingSliderOptions = {
				floor: FLOORS_IN_BUILDING_SLIDER_FLOOR,
				ceil: FLOORS_IN_BUILDING_SLIDER_CEIL,
				step: FLOORS_IN_BUILDING_SLIDER_STEP,
				showTicks: false
			};


			// if (!this.slidersInitialized) {
			this.roomsSlider.roomsMin = this.roomsSlider.roomsMin || ROOM_SLIDER_FLOOR;
			this.roomsSlider.roomsMax = this.roomsSlider.roomsMax || ROOM_SLIDER_CEIL;
			this.bathroomSlider.bathroomsMin = this.bathroomSlider.bathroomsMin || BATHROOM_COUNT_FLOOR;
			this.bathroomSlider.bathroomsMax = this.bathroomSlider.bathroomsMax || BATHROOM_COUNT_CEIL;
			this.advancedSearchFormData.floorMin = this.advancedSearchFormData.floorMin || FLOOR_SLIDER_FLOOR;
			this.advancedSearchFormData.floorMax = this.advancedSearchFormData.floorMax || FLOOR_SLIDER_CEIL;
			this.innerHeightSlider.innerHeightMin = this.innerHeightSlider.innerHeightMin || INNER_HEIGHT_SLIDER_FLOOR;
			this.innerHeightSlider.innerHeightMax = this.innerHeightSlider.innerHeightMax || INNER_HEIGHT_SLIDER_CEIL;
			this.advancedSearchFormData.floorsInBuildingMin = this.advancedSearchFormData.floorsInBuildingMin || FLOORS_IN_BUILDING_SLIDER_FLOOR;
			this.advancedSearchFormData.floorsInBuildingMax = this.advancedSearchFormData.floorsInBuildingMax || FLOORS_IN_BUILDING_SLIDER_CEIL;
			this.slidersInitialized = true;
			// }


		}

		saveBathrooms(id, min, max) {
			this.bathroom.bathroomsMax = BATHROOM_VALUES[max];
			this.bathroom.bathroomsMin = BATHROOM_VALUES[min];
			if (max == BATHROOM_COUNT_CEIL) {
				this.advancedSearchFormData.bathroomsMax = '';
				this.advancedSearchFormData.bathroomsMin = min;
			} else {
				this.advancedSearchFormData.bathroomsMax = max;
				this.advancedSearchFormData.bathroomsMin = min;
			}
		}

		saveRooms(id, min, max) {
			let minIndex = ROOM_VALUES.indexOf(min.toString());
			let maxIndex = max == ROOM_SLIDER_CEIL ? ROOM_VALUES.indexOf('10+') : ROOM_VALUES.indexOf(max.toString());
			this.rooms.roomsMax = ROOM_VALUES[maxIndex];
			this.rooms.roomsMin = ROOM_VALUES[minIndex];
			if (max == ROOM_SLIDER_CEIL) {
				this.advancedSearchFormData.roomsMax = '';
				this.advancedSearchFormData.roomsMin = min;
			} else {
				this.advancedSearchFormData.roomsMax = max;
				this.advancedSearchFormData.roomsMin = min;
			}
		}

		setInnerHeight(id, min, max) {
			let minIndex = INNER_HEIGHT_SLIDER_VALUES.indexOf((parseFloat(min)).toFixed(1));
			let maxIndex = max == INNER_HEIGHT_SLIDER_CEIL ? INNER_HEIGHT_SLIDER_VALUES.indexOf('10+') :
				INNER_HEIGHT_SLIDER_VALUES.indexOf((parseFloat(max)).toFixed(1));
			this.innerHeight.innerHeightMax = INNER_HEIGHT_SLIDER_VALUES[maxIndex];
			this.innerHeight.innerHeightMin = INNER_HEIGHT_SLIDER_VALUES[minIndex];
			if (max == INNER_HEIGHT_SLIDER_CEIL) {
				this.advancedSearchFormData.innerHeightMax = '';
				this.advancedSearchFormData.innerHeightMin = min;
			} else {
				this.advancedSearchFormData.innerHeightMax = max;
				this.advancedSearchFormData.innerHeightMin = min;
			}
		}


		saveAdvancedSearchData() {
			if (this.saveAdvancedSearchDataFunction) {
				this.saveAdvancedSearchDataFunction({data: this.advancedSearchFormData});
			}

		}

		conditionOfPropertyChanged(prop) {
			if (this.conditionOfProperty[prop]) {
				this.advancedSearchFormData.conditionOfProperty.push(prop);
			} else {
				this.advancedSearchFormData.conditionOfProperty.splice(this.advancedSearchFormData.conditionOfProperty.indexOf(prop), 1);
			}
		}

		buildingStructureChanged(materia) {
			if (this.buildingStructure[materia]) {
				for (let i = 0; i < BUILDING_MATERIALS[materia].length; i++) {
					this.advancedSearchFormData.buildingStructure.push(BUILDING_MATERIALS[materia][i]);
				}
			} else {
				for (let i = 0; i < BUILDING_MATERIALS[materia].length; i++) {
					let startIndex = this.advancedSearchFormData.buildingStructure.indexOf(BUILDING_MATERIALS[materia][i]);
					this.advancedSearchFormData.buildingStructure.splice(startIndex, 1);
				}
			}
		}

		heatingChanged(type) {
			if (this.heating[type]) {
				for (let i = 0; i < HEATING_TYPES[type].length; i++) {
					this.advancedSearchFormData.heating.push(HEATING_TYPES[type][i]);
				}
			} else {
				for (let i = 0; i < HEATING_TYPES[type].length; i++) {
					this.advancedSearchFormData.heating.splice(this.advancedSearchFormData.heating.indexOf(HEATING_TYPES[type][i]), 1);
				}
			}
		}

		setElevator() {
			if (this.elevator.EXIST) {
				this.advancedSearchFormData.elevator = ELEVATOR_VALUES.EXIST;
			} else {
				this.advancedSearchFormData.elevator = ELEVATOR_VALUES.NONE;
			}
		}

		floorSliderChanged(id, min, max) {
			this.advancedSearchFormData.floor = [];
			for (let i = min; i <= max; i++) {
				this.advancedSearchFormData.floor.push(FLOOR_VALUES[i]);
			}
		}

		comfortChange(type) {
			if (this.comfortLevel[type]) {
				for (let i = 0; i < COMFORT_LEVELS[type].length; i++) {
					this.advancedSearchFormData.comfortLevel.push(COMFORT_LEVELS[type][i]);
				}
			} else {
				for (let i = 0; i < COMFORT_LEVELS[type].length; i++) {
					this.advancedSearchFormData.comfortLevel.splice(this.advancedSearchFormData.comfortLevel.indexOf(COMFORT_LEVELS[type][i]), 1);
				}
			}
		}

		parkingChanged(prop) {
			if (this.parking) {
				this.advancedSearchFormData.parkingOption = PARKING_ARRAY;
			} else {
				this.advancedSearchFormData.parkingOption = [];
			}
		}

		terraceChanged() {
			if (this.roomTypes.terrace) {
				this.advancedSearchFormData['rooms.type'] = TERRACE_PROPERTIES.terrace;
			} else {
				delete this.advancedSearchFormData['rooms.type'];
			}
		}

		viewChanged(prop) {
			if (this.view[prop]) {
				this.advancedSearchFormData.view.push(prop);
			} else {
				this.advancedSearchFormData.view.splice(this.advancedSearchFormData.view.indexOf(prop), 1);
			}
		}

		staircaseTypeChanged(prop) {
			if (this.staircaseType[prop]) {
				this.advancedSearchFormData.staircaseType.push(prop);
			} else {
				this.advancedSearchFormData.staircaseType.splice(this.advancedSearchFormData.staircaseType.indexOf(prop), 1);
			}
		}

		livingRoomOrientationChanged(type) {
			this.advancedSearchFormData.livingRoomOrientation = [];
			for (let key in this.livingRoomOrientation) {
				if (this.livingRoomOrientation[key]) {
					for (let i = 0; i < LIVING_ROOM_ORIENTATIONS[key].length; i++) {
						this.advancedSearchFormData.livingRoomOrientation.push(LIVING_ROOM_ORIENTATIONS[key][i]);
					}
				}
			}
			let setValue = new Set(this.advancedSearchFormData.livingRoomOrientation);
			this.advancedSearchFormData.livingRoomOrientation = Array.from(setValue);
		}

		poolChanged() {
			this.advancedSearchFormData.hasPoolOrSwimmingPool = this.miscellaneous.pool;
		}

		gardenChanged() {
			this.advancedSearchFormData.hasGardenOrPark = this.miscellaneous.withGardenAccess;
		}

		topFloorChanged() {
			this.advancedSearchFormData.isInAttic = this.miscellaneous.topFloor;
		}

		savekeyWord() {
			this.advancedSearchFormData.keyWord = this.keyWord.replace(/\s\s+/g, ' ');
		}

		saveMNumber() {
			this.advancedSearchFormData.mNumber = this.mNumber.replace(/\s\s+/g, ' ');
		}
	}
};

